exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".categories-select .vue-treeselect__control,.tags-select .vue-treeselect__control{font-size:.875rem!important}.products-table{height:75vh;font-size:9pt}.products-table .products-thumbs{width:50px;max-height:50px}.products-table .products-table-style-actions{width:120px}.products-table .products-table-style-actions .actions-icons{text-align:center}.products-table .filter-inline input{min-width:35px;width:100%;padding:2px;font-size:9pt}.products-table .b-table-top-row #filter-checkbox{display:none}", ""]);

// exports
